module.exports = __webpack_public_path__ + "img/chart_icon.231023dc.svg";